import axios from 'axios'
import * as T from './types'

/**
 * Default headers untuk request ke API
 */
export const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  apikey: '1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
}

const api_masterdata = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_MASTERDATA,
})

const api_management = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT,
})

const api_h2h = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_H2H,
})

const api_sap = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_SAP,
})

const api_auth = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API,
})

/**
 * Mutation untuk menghapus file attachment berdasarkan id
 */
export const deleteAttachment = (attachmentId: number) => {
  const endpoint = `/attachment/delete/${attachmentId}`
  const token = localStorage.getItem('token') as string
  return api_management.delete(endpoint, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

/**
 * Mutation untuk upload file attactment
 */
export const uploadAttachment = ({attachment_type, formData: data}: T.IUploadAttachmentPayload) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/attachment/create/${attachment_type}`
  return api_management.post(endpoint, data, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

/**
 * Mutation untuk update so item
 */
export const updateSoItem = (payload: T.IUpdateSoItemPayload) => {
  const {id_soitem, ...data} = payload
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/sales-order/so-item/${id_soitem}?credentials=${credentials}`
  return api_management.put(endpoint, data, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}
